import { Injectable } from '@angular/core';
import { UpdatesHandlerService } from './updates-handler';
import { Observable } from 'rxjs';

@Injectable()
export class UpdatesService {
  constructor(private updatesHandlerService: UpdatesHandlerService) {}

  getUpdateExistsEvent(): Observable<any> {
    return this.updatesHandlerService.updateExists$;
  }

  getUpdateInstalledEvent(): Observable<any> {
    return this.updatesHandlerService.updateInstalled$;
  }

  getUpdateActivatedEvent(): Observable<any> {
    return this.updatesHandlerService.updateActivated$;
  }

  activateUpdateAsync(): Promise<void> {
    return this.updatesHandlerService.activateUpdateAsync();
  }
}
